import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import {
  Produktlinie,
  UebergreifendItem,
  VersicherungsSummeEnum,
  ZusatzoptionItem,
} from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectSelectedProduktlinie = (state: IAppState): Produktlinie =>
  getSelectedProduktlinie(state.produkt);

export const selectZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItem> => {
  return getSelectedProduktlinie(state.produkt)?.zusatzoptionen || [];
};

export const selectProduktlinien = (state: IAppState): Array<Produktlinie> =>
  state.produkt?.produktlinien || [];

export const selectUebergreifendeLeistungen = (state: IAppState): Array<UebergreifendItem> =>
  state.produkt?.uebergreifend || [];

export const selectSelectedZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItem> => {
  return selectZusatzoptionItems(state).filter(elem => elem.isSelected);
};

export const selectSelectedProduktlinieIndex = (state: IAppState): number => {
  return selectProduktlinien(state).findIndex(produktlinie => produktlinie.selected);
};

export const selectGesamtbeitrag = (state: IAppState): number => state.gesamtbeitrag;

export const selectSelectedVersSumme = (state: IAppState): number => {
  const selectedProduktLinie = getSelectedProduktlinie(state.produkt);
  let verSummeNumber: number = null;
  const selectedLeistungVersSumme = selectedProduktLinie
    ? selectedProduktLinie.leistungen.find(elem => elem.id === 'versicherungssumme')
    : null;
  if (selectedLeistungVersSumme !== null) {
    if (selectedLeistungVersSumme.eigenschaft === VersicherungsSummeEnum.FUENFZEHN_MIO) {
      verSummeNumber = 15000000;
    } else if (selectedLeistungVersSumme.eigenschaft === VersicherungsSummeEnum.FUENFZIG_MIO) {
      verSummeNumber = 50000000;
    } else if (
      selectedLeistungVersSumme.eigenschaft === VersicherungsSummeEnum.FUENFUNDSIEBZIG_MIO
    ) {
      verSummeNumber = 75000000;
    } else if (selectedLeistungVersSumme.eigenschaft === VersicherungsSummeEnum.HUNDERT_MIO) {
      verSummeNumber = 100000000;
    }
  }
  return verSummeNumber;
};
